import { render, staticRenderFns } from "./Placements.ts.vue?vue&type=template&id=789a0b5b"
import script from "./Placements.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Placements.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports